module.exports = __webpack_public_path__ + "img/corner-left-down.ab42e21b.svg";